import SuccessIcon from "@assets/icons/success_32px.svg?react";
import { BulkSuccessDialogContent } from "@components/common/faro-table/bulk-dialog/bulk-dialog-types";
import { Stack, SvgIcon, Typography } from "@mui/material";
import { useAppDispatch } from "@store/store-helper";
import { setBulkActionName } from "@store/table/table-slice";
import { getSvgColoredIconCss } from "@utils/ui-utils";
import { Dialog, green } from "@flat-ui";

interface Props {
  /** The content of the dialog */
  dialogContent: BulkSuccessDialogContent;
}

/** Show success message if all the bulk actions are successful */
export function BulkSuccessDialog({ dialogContent }: Props): JSX.Element {
  const dispatch = useAppDispatch();

  return (
    <Dialog
      open={true}
      title={
        <Stack direction="row" alignItems="center">
          <SvgIcon
            inheritViewBox
            component={SuccessIcon}
            sx={{
              ...getSvgColoredIconCss(green[700]),
              height: "28px",
              width: "28px",
              mr: "12px",
            }}
          />
          {dialogContent.title}
        </Stack>
      }
      onConfirm={() => {
        dispatch(setBulkActionName(null));
      }}
      confirmText="Done"
    >
      <Typography
        sx={{
          fontSize: "14px",
        }}
      >
        {dialogContent.description}
      </Typography>
    </Dialog>
  );
}
